import { gql } from '@apollo/client';

const SKIP_ASSIGNMENT = gql`
  mutation skipAssignment($data: AssignmentSkipInput!) {
    skipAssignment(data: $data) {
      id
      studentId
      files {
        id
        description
      }
      dateStarted
      dateCompleted
    }
  }
`;

export default SKIP_ASSIGNMENT;
